<template>
  <el-container>
    <el-header style="width: 79rem; padding: 0">
      <el-container style="line-height: 4rem">
        <el-aside width="58rem" style="background-color: #EEE; font-size: 1.4rem">
          <el-row style="padding: 0.5rem; line-height: 3rem">
            <el-col :span="8">姓名：{{ orderInfo.realName }}</el-col>
            <el-col :span="8">账户可用额：{{ orderInfo.userAccountBalance }}</el-col>
            <el-col :span="8">读取时间：{{ orderInfo.readTime }}</el-col>
          </el-row>
          <el-row style="padding: 0.5rem; line-height: 3rem">
            <el-col :span="8">时段：{{ orderInfo.partOfDay }}</el-col>
            <el-col :span="8">合计：{{ orderInfo.orderAmount }}</el-col>
            <el-col :span="8">取餐状态：{{ orderInfo.orderStatus }}</el-col>
          </el-row>
          <el-row>
            <el-table :data="orderInfo.orderDetailList" border stripe style="font-size: 1.4rem; line-height:3rem">
              <el-table-column prop="goodsName" label="菜品" width="645"></el-table-column>
              <el-table-column prop="qty" label="份数" width="80"></el-table-column>
              <el-table-column prop="goodsPrice" label="单价" width="100" :formatter="yuanOfGoodsPriceFormatter"></el-table-column>
              <el-table-column prop="detailAmount" label="总额" width="100" :formatter="yuanOfDetailAmountFormatter"></el-table-column>
            </el-table>
          </el-row>
        </el-aside>
        <el-main style="height: 720px; padding: 0 0 0 0.3rem; text-align: center; font-size: 1.4rem;">
          <el-row style="height: 9.5rem; padding: 1rem 0; line-height: 2.5rem; background-color: #EEE">
            <el-col :span="24">{{ dateStr }}</el-col>
            <el-col :span="24">{{ timeStr }}</el-col>
            <el-col :span="24">{{ partOfDay }}</el-col>
          </el-row>
          <el-row style="height: 7rem; padding: 1rem 0; line-height: 2.5rem; background-color: #DDD; font-size: 1.4rem">
            <el-col :span="24">设备编号：{{ deviceNo }}</el-col>
            <el-col :span="24">{{ connectStatus }}</el-col>
          </el-row>
          <el-row style="height: 28.5rem; line-height: 4rem; padding: 6rem 0.5rem; background-color: #EEE">
            <el-col :span="24" style="text-align: center">
              <img width=250 style="margin-top: -4px" :src="canteenQrCode" />
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </el-header>
  </el-container>
</template>

<script>
export default ({
  data () {
    return {
      loginForm: {
        userName: '',
        password: '',
        userType: '2'
      },
      websock: null,
      dateStr: '',
      timeStr: '',
      partOfDay: '',
      connectStatus: '',
      deviceNo: '',
      orderInfo: {},
      canteenQrCode: '',
      getCanteenQrCodeInterval: null
    }
  },
  computed: {
    userTypeDisable () {
      return !/^\d{11}$/.test(this.loginForm.userName)
    }
  },
  mounted () {
    this.getDeviceNo()
    this.getTime()
  },
  created () {
    this.initWebSocket()
  },
  destroyed () {
    this.websock.close()
  },
  methods: {
    getDeviceNo () {
      let deviceNoArr = /no=([^#]+)/.exec(window.location.href)
      if (deviceNoArr !== null && deviceNoArr[1] != null) {
        this.deviceNo = '202102' + ('0000' + deviceNoArr[1]).slice(-4)
      }
    },
    getTime () {
      let _this = this
      this.$axios.get(this.GLOBAL.host + '/time').then(res => {
        if (res.data && res.data.status === 200 && res.data.data) {
          let timestamp = res.data.data
          setInterval(function () {
            timestamp += 1
            let time = new Date(timestamp * 1000)
            let year = time.getFullYear()
            let month = time.getMonth() + 1
            let date = time.getDate()
            let weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
            let weekDay = weekDays[time.getDay()]
            let hours = '0' + time.getHours()
            let minutes = '0' + time.getMinutes()
            let seconds = '0' + time.getSeconds()
            _this.dateStr = year + '年' + month + '月' + date + '日 ' + weekDay
            _this.timeStr = hours.substr(-2) + ':' + minutes.substr(-2) + ':' + seconds.substr(-2)
            if (_this.timeStr < '10:00:00') {
              _this.partOfDay = '早餐时间'
            } else if (_this.timeStr < '15:00:00') {
              _this.partOfDay = '午餐时间'
            } else {
              _this.partOfDay = '晚餐时间'
            }
          }, 1000)
        }
      })
    },
    yuanOfGoodsPriceFormatter (row) {
      return this.fenToyuanFormat(row.goodsPrice)
    },
    yuanOfDetailAmountFormatter (row) {
      return this.fenToyuanFormat(row.detailAmount)
    },
    fenToyuanFormat (fen) {
      let yuan = ''
      if (fen !== 0) {
        yuan = fen / 100 + '元'
      }
      return yuan
    },
    getCanteenQrCode () {
      let _this = this
      clearInterval(this.getCanteenQrCodeInterval)
      this.websocketsend('getCanteenQrCode_' + this.deviceNo)
      this.getCanteenQrCodeInterval = setInterval(function () {
        _this.websocketsend('getCanteenQrCode_' + _this.deviceNo)
      }, 600 * 1000)
    },
    initWebSocket () {
      // 初始化weosocket
      this.connectStatus = '正在连接'
      this.websock = new WebSocket(this.GLOBAL.wsHost)
      this.websock.onopen = this.websocketonopen
      this.websock.onmessage = this.websocketonmessage
      this.websock.onerror = this.websocketonerror
      this.websock.onclose = this.websocketclose
    },
    websocketonopen () {
      this.connectStatus = '已连接'
      // 连接建立之后执行send方法发送数据
      this.websocketsend('bindCanteenDevice_' + this.deviceNo)
      if (this.dateStr === '' || this.timeStr === '' || this.partOfDay === '') {
        this.getTime()
      }
      this.getCanteenQrCode()
    },
    websocketonerror () {
      // 连接建立失败
      // console.log('连接失败')
    },
    websocketonmessage (e) {
      // 数据接收
      // console.log('receive message: ' + e.data)
      let _this = this
      if (e.data != null) {
        console.log(e.data)
        if (e.data.substring(0, 17) === 'sendCanteenOrder_') {
          _this.orderInfo = JSON.parse(e.data.substring(17))
          _this.getCanteenQrCode()
        } else if (e.data.substring(0, 18) === 'sendCanteenQrCode_') {
          let message = JSON.parse(e.data.substring(18))
          if (message != null && message.canteenQrCode != null) {
            this.canteenQrCode = message.canteenQrCode
          }
        }
      }
    },
    websocketsend (Data) {
      // 数据发送
      this.websock.send(Data)
    },
    websocketclose (e) {
      // 断开连接
      this.connectStatus = '连接失败，尝试重新连接'
      let _this = this
      setTimeout(function () {
        _this.initWebSocket()
      }, 5000)
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/CanteenCustomerSide.vue